import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ArchivosService } from 'app/services/archivos.service';
import { UploadImage } from 'app/interfaces/upload-images.interface';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.css'],
})
export class UploadFileComponent implements OnInit {
  @ViewChild('fileInput') inputEl: ElementRef;

  urlFIle: string = '';
  nombreArchivo: string = '';
  nombre: string = '';
  procesando = false;
  subiendo = false;
  erroresFile: string[] = [];
  mensaje = '';
  type;
  excelFile: File;
  errorMessage: string | null = null;

  constructor(
    private archivoServicio: ArchivosService,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<UploadFileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.mensaje = this.data.mensaje;
    this.type = this.data.type;
  }

  ngOnInit(): void {}

  salir(): void {
    this.dialogRef.close();
  }

  onFileSelected(event) {
    const file: File = event.target.files[0];
    const input = event.target as HTMLInputElement;
    this.errorMessage = null;
    this.nombreArchivo = file.name;
    this.excelFile = file;

    const allowedExtensions = this.getAllowedExtensions();

    // Valida si el archivo tiene una extensión permitida
    const isValidFile = allowedExtensions.some(ext => this.nombreArchivo.endsWith(ext));

    if (!isValidFile && allowedExtensions.length > 0) {
      this.errorMessage = `Formato no válido. Solo se permiten: ${allowedExtensions.join(
        ', '
      )}`;
      this.nombreArchivo = '';
      input.value = '';
      return;
    }
    if (file && this.type === 'articulos') {
      this.procesando = true;
      this.archivoServicio.importarArchivoExcel(file).subscribe(
        (res: UploadImage) => {
          console.log({ res });
          this.urlFIle = res.data?.url;
          this.nombre = res.data?.originalname;
          this.procesando = false;
        },
        err => {
          this.openSnackBar(`Error al validar el archivo`, 'Información');
          this.procesando = false;
        }
      );
    }
    if ((file && this.type === 'ventas') || this.type === 'compras') {
      this.procesando = true;

      this.archivoServicio
        .subirImagen(file)
        .then(res => {
          this.urlFIle = res.data?.url;
          this.nombre = res.data?.originalname;
          this.procesando = false;
          this.dialogRef.close(this.urlFIle);
        })
        .catch(err => {
          this.openSnackBar(`Error al validar el archivo`, 'Información');
          this.procesando = false;
        });
    }
  }

  procesarArchivo() {
    // procedemos a guardar el archivo y esperar que termine de procesarlo
    this.subiendo = true;
    if (this.type === 'articulos') {
      this.archivoServicio.procesarArchivoExcel(this.nombre).subscribe(
        res => {
          this.openSnackBar(`Excelente! Archivo procesado correctamente`, 'Información');
          this.subiendo = false;
          this.salir();
        },
        err => {
          this.subiendo = false;
          if (err.error) {
            this.openSnackBar(err.message, 'Error');
          } else {
            this.openSnackBar(`Error procesar el archivo`, 'Error');
          }
        }
      );
    }
    if (this.type === 'clientes') {
      this.archivoServicio.procesarArchivoExcelClientes(this.urlFIle).subscribe(
        res => {
          this.openSnackBar(`Excelente! Archivo procesado correctamente`, 'Información');
          this.subiendo = false;
          this.salir();
        },
        err => {
          this.subiendo = false;
          this.openSnackBar(`Error procesar el archivo`, 'Error');
        }
      );
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
    });
  }

  getAcceptValue(): string {
    switch (this.type) {
      case 'articulos':
      case 'clientes':
        return '.xls, .xlsx';
      case 'ventas':
      case 'compras':
        return '.pdf, .jpg, .jpeg, .png';
      default:
        return '*';
    }
  }

  getAllowedExtensions(): string[] {
    switch (this.type) {
      case 'articulos':
      case 'clientes':
        return ['.xls', '.xlsx'];
      case 'ventas':
      case 'compras':
        return ['.pdf', '.jpg', '.jpeg', '.png'];
      default:
        return [];
    }
  }
}
